import { trackEvent } from "../analytics/events.js";

export async function initWebVitalsTracking() {
  try {
    const { onCLS, onFCP, onINP, onLCP, onTTFB } = await import("web-vitals");
    const report = (metric) => {
      trackEvent("web_vital", {
        name: metric.name,
        value: Number(metric.value?.toFixed?.(2) || metric.value || 0),
        id: metric.id,
        rating: metric.rating || "unknown",
      });
    };
    onCLS(report);
    onFCP(report);
    onINP(report);
    onLCP(report);
    onTTFB(report);
  } catch (_) {
    // Web vitals are optional in non-browser/test environments.
  }
}

